import React, { useState } from "react";
import { Dropdown } from "antd";
import { Button, Spinner } from "reactstrap";
import { ThreeDotsIcon } from "../../assets/icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { MoreVerticalIcon } from "@hugeicons/core-free-icons/index";

const ActionDropdown = ({
  items = [],
  onMenuClick,
  trigger = ["click"],
  placement = "bottomRight",
  className = "",
  buttonSize = "xs",
  buttonVariant = "secondary",
  buttonClassName = "outline btn-icon H6 text-primary btn-sm",
  disabled = false,
  loading = false,
  removeContainer = false,
  iconAlign = "horizontal",
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const handleMenuClick = (e) => {
    if (onMenuClick) {
      onMenuClick(e);
    }
    setOpen(false);
  };

  const handleOpenChange = (nextOpen, info) => {
    if (info.source === "trigger" || nextOpen) {
      setOpen(nextOpen);
    }
  };

  return (
    <div className={className} id="drop">
      <Dropdown
        trigger={trigger}
        getPopupContainer={() => removeContainer ? null : document.getElementById("drop")}
        menu={{
          items,
          onClick: handleMenuClick,
        }}
        onOpenChange={handleOpenChange}
        open={open}
        placement={placement}
        disabled={disabled}
        {...props}
      >
        <span>
          <Button
            variant={buttonVariant}
            size={buttonSize}
            className={buttonClassName}
            disabled={disabled || loading}
            type="button"
          >
            {loading ? <Spinner size="sm" /> : null}
            {iconAlign === "horizontal" ? <ThreeDotsIcon /> : <HugeiconsIcon size={18} icon={MoreVerticalIcon} />}
          </Button>
        </span>
      </Dropdown>
    </div>
  );
};

export default ActionDropdown;
